import {
    Alert,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";
import { useEffect } from "react";
import CustomAlert from "../CustomAlert";
import {
    QUERY_CAN_TEACH_DOMAIN_USERS_AND_THEIR_AVAILABILITY_FILTERED_BY_TIME,
    DELETE_SHIFT
} from "../../queries/GraphQLQueries";
import { useDialogNavigation } from "../../hooks/useDialogNavigation";

const DATE_FORMAT = "Do MMM YYYY, HH:mm";

export default function DeleteShiftDialog() {

    const handleCancel = useDialogNavigation();
    const { state } = useLocation();
    const [alertMessage, setAlertMessage] = useState(null);
    const [displayWarning, setDisplayWarning] = useState(false);
    const [warningMessage, setWarningMessage] = useState(null);

    const [deleteShift, { updatedData, loadingMutation, mutationError }] = useMutation(DELETE_SHIFT, {
        refetchQueries: [{ query: QUERY_CAN_TEACH_DOMAIN_USERS_AND_THEIR_AVAILABILITY_FILTERED_BY_TIME }, 'GetTeachingUsersAndTheirAvailability']
    });
    const handleCloseCustomAlert = () => {
        setAlertMessage(null);
    };
    const { shiftToDelete } = state || {};

    useEffect(() => {

        if (shiftToDelete) {

            const now = moment();
            if (now.isAfter(shiftToDelete.shiftEndTime)) {
                setDisplayWarning(true);
                setWarningMessage('Warning: This shift is in the past');
            } else if (now.isAfter(shiftToDelete.shiftStartTime) && now.isBefore(shiftToDelete.shiftEndTime)) {
                setDisplayWarning(true);
                setWarningMessage('Warning: This shift is currently in progress');
            }
        }
    }, [shiftToDelete]);

    function handleDelete() {
        setAlertMessage({ children: 'Deleting Shift...', severity: 'success' });

        deleteShift(
            {
                variables: {
                    shiftId: shiftToDelete.availabilityId
                }
            }).then(() => {
                handleCancel();
            }).catch(error => {
                setAlertMessage({ children: error?.message, severity: 'error' });
                console.log(error);
            });
    }

    return <>
        <Dialog open={true}>
            {displayWarning &&
                <Alert variant="filled" severity="warning">
                    {warningMessage}
                </Alert>
            }
            <DialogTitle>{`Delete Shift `}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ p: 2 }} alignItems="left" justifyContent="left" direction="column">

                    <TextField id="recordId" label="Performer" value={shiftToDelete.displayName}
                        InputProps={{ readOnly: true, disabled: true }} autoFocus = {false} />
                    <TextField id="recordId" label="Start Time" value={moment(shiftToDelete.shiftStartTime).format(DATE_FORMAT)}
                        InputProps={{ readOnly: true, disabled: true }} autoFocus = {false} />
                    <TextField id="recordId" label="End Time" value={moment(shiftToDelete.shiftEndTime).format(DATE_FORMAT)}
                        InputProps={{ readOnly: true, disabled: true }} autoFocus = {false} />

                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button onClick={handleDelete}>Delete</Button>
            </DialogActions>
        </Dialog>
        <CustomAlert alertMessage={alertMessage} handleCloseCustomAlert={handleCloseCustomAlert} />
    </>;
}
